$ = jQuery;

// Console.log fix
if ( typeof console == 'undefined' ) {
	console = {};
}
if ( typeof console.log == 'undefined' ) {
	console.log = function () {}
}
if ( typeof console.error == 'undefined' ) {
	console.error = function () {}
}

// Modernizr : D
if ( typeof SVGRect != "undefined" ) {
	DOM_html.className += ' svg';
} else {
	DOM_html.className += ' no-svg';
}

var $body = null;
var $site = null;
var fz;

$(document).ready(function() {
	$body = $('body');
	$site = $('#site-content');

	if ( is_webkit() ) {
		$body.addClass('webkit');
	}
	$body.addClass('body-ready');

	$(window).resize();
});

$(window).on('load',function() {
	$('body').addClass('page-loaded');
	$(window).resize();
	setTimeout(function() {
		$(window).resize();
	},500);
});
window.addEventListener("orientationchange", function() {
	$(window).resize();
}, false);


$(window).resize(function() {
	// Font size
	if ( $site ) {
		if ( $site.length ) {
			var w = $site.width();
			if ( !is_tablet() ) {
				if ( w < 1024 ) {
					//w = 1024;
				}
				fz = w / 1280;
				if ( fz > 1 ) {
					fz = 1;
				}
			} else {
				if ( w > 640 ) {
					w = 640;
				}
				fz = w / 320;
			}
			$body.css('font-size', ( fz * 100 ) + '%');
			$('.js-fz').css('transform','scale('+fz+')');
		}
	}
	$(window).scroll();
});

$(document).ready(function(){
	var stp = 0;
	$(window).scroll(function() {
		var st = $(window).scrollTop();
		var $hh = $('.header').add('.header-banner');
		if ( st > 100 ) {
      $hh.addClass('scrolled2');
		} else {
      $hh.removeClass('scrolled2');
		}
		if ( Math.abs(st - stp) > 2 ) {
			if ( st > 300 && ( st - stp ) > 0 && !$('.menu-opener').hasClass('open') ) {
        $hh.addClass('scrolled');
			} else {
        $hh.removeClass('scrolled');
			}
		}
		stp = st;
	});
});

var $tablet_detect = null;
function is_tablet () {
	if ( !$tablet_detect ) {
		$tablet_detect = jQuery('#tablet-detect');
	}
	return $tablet_detect.is(':visible');
}
function is_mobile () {
	return is_tablet();
	//return $('#mobile-detect').is(':visible');
}
function is_webkit () {
	return "webkitLineBreak" in document.documentElement.style;
}
function wait () {
	return '<div class="wait"></div>';
}
function remove_wait ( $wrap ) {
	$wrap.find('.wait').fadeOut(200, function () {
		jQuery(this).remove();
	});
}
function scrollto ( $elem ) {
	var ot = $elem.offset().top - $('.header').height();
	var st = ot;
	jQuery('body,html').animate({
		scrollTop: st,
	}, {
		duration: 500
	});
}

// To Top
$(document).ready(function() {
  $(window).scroll(function() {
    if ( $(window).scrollTop() > 100 ) {
      $('.totop').addClass('totop--active');
    } else {
      $('.totop').removeClass('totop--active');
    }
  });
});

// Mobile menu
$(document).ready(function() {
	$(document).on('click','.menu-opener',function() {
		var $o = $(this);
		var $m = $('.header-menu');
		var $h = $('.header');
		$o.toggleClass('open');
		if ( $o.hasClass('open')) {
			$m.addClass('open');
      $h.addClass('menu-open');
		} else {
			$m.removeClass('open');
      $h.removeClass('menu-open');
		}
	});
  $(document).on('click','.expander',function() {
    var $ul_top = $(this).closest('ul');
    var $ul = $(this).closest('li').find('ul');
    var $ul_others = $ul_top.find('>li>ul').not($ul);
    var $back = $('.menu-back');
    $ul_others.hide();
    $ul.show();
    $ul_top.height($ul.height());
    $ul_top.addClass('level-2');
    $back.show();
  });
  $(document).on('click','.menu-back',function() {
    var $ul_top = $('.header-menu-scroll > ul');
    var $back = $(this);
    $ul_top.css('height','auto')
    $ul_top.removeClass('level-2');
    $back.hide();
  });
});

// Logo rotating
/*$(document).ready(function() {
	$('.logo').each(function() {
		var $w = $(this);
		$w.data('r',0);
		var $c = $w.find('.logo-circle');
		var t = null;
		var is_rotating = false;
		var is_hover = false;
		var rotate = function() {
			if ( is_hover && !is_rotating ) {
				is_rotating = true;
				var r = $w.data('r');
				r ++;
				//console.log(r);
				if ( r > 4 ) {
					r = 1;
					$c.addClass('no-transition');
					$w.attr('class', function(i, c){
						return c.replace(/(^|\s)r\S+/g, '');
					});
					setTimeout(function() {
						$c.removeClass('no-transition');
						$c[0].offsetHeight;
						$w.addClass('r1');
					},1);
				} else {
					$w.attr('class', function(i, c){
						return c.replace(/(^|\s)r\S+/g, '');
					});
					$w.addClass('r'+r);
				}
				$w.data('r',r);
				t = setTimeout(function() {
					is_rotating = false;
					rotate();
				},1550);
			}
		};
		$w.on('mouseenter',function(e) {
			is_hover = true;
			if ( !is_rotating ) {
				rotate();
			}
		}).on('mouseleave',function(e) {
			is_hover = false;
		});
	});
});*/

// Home Head Slider
$(document).ready(function() {
	$('.block-full--home-head-slider .home-head-slider').slick({
		dots: true,
		arrows: true,
		speed: 800,
		swipeToSlide: true,
		fade: true,
		infinite: true,
		adaptiveHeight: false,
		autoplay: true,
		autoplaySpeed: 6000,
    appendArrows: $('.home-head-slider-controls'),
    appendDots: $('.home-head-slider-controls'),
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					arrows: true,
				}
			},
		]
	}).on('beforeChange', function( e, slick, currentSlide, nextSlide ) {
		var $slide = $(this).find('.slick-slide[data-slick-index="'+nextSlide+'"]');
	  var $slides = $(this).find('.slick-slide').not('[data-slick-index="'+currentSlide+'"]');
		var $s = $slides.find('.home-head-slide .js-scroll');
		$s.css('transition','none');
		$s.each(function() {
		  var $ss = $(this);
		  $ss.scroll_obj_get().scrolled_reset();
    });
		/*if ( $slide.find('.home-head-slide').hasClass('text-color-blue')) {
		  $('.header').addClass('header-text-blue');
    } else {
      $('.header').removeClass('header-text-blue');
    }*/
	}).on('afterChange', function( e, slick, currentSlide ) {
		var $s = $(this).find('.home-head-slide .js-scroll');
    $s.removeAttr('style');
		$(window).scroll();
	});

	/*if ( $('.block-full--home-head-slider .slick-slide[data-slick-index="0"] .home-head-slide').hasClass('text-color-blue')) {
    $('.header').addClass('header-text-blue');
  }*/

  $('.block-full--home-head-slider .slick-slide[data-slick-index="0"] .js-scroll').css({
    transition: 'none',
    transform: 'none',
    opacity: 1,
  });
});

// History Slider
$(document).ready(function() {
  $('.block-full--history-slider .history-slider').slick({
    dots: true,
    arrows: true,
    speed: 800,
    swipeToSlide: true,
    fade: true,
    infinite: true,
    adaptiveHeight: false,
    autoplay: true,
    autoplaySpeed: 8000,
    appendArrows: $('.history-slider-controls'),
    appendDots: $('.history-slider-controls'),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          speed: 400,
          adaptiveHeight: true,
        }
      },
    ]
  }).on('beforeChange', function( e, slick, currentSlide, nextSlide ) {
    var $slide = $(this).find('.slick-slide[data-slick-index="'+nextSlide+'"]');
    var $slides = $(this).find('.slick-slide').not('[data-slick-index="'+currentSlide+'"]');
    var $s = $slides.find('.history-slide .js-scroll');
    if ( !is_mobile()) {
      $s.css('transition', 'none');
      $s.each(function() {
        var $ss = $(this);
        $ss.scroll_obj_get().scrolled_reset();
      });
    }
  }).on('afterChange', function( e, slick, currentSlide ) {
    var $s = $(this).find('.history-slide .js-scroll');
    $s.removeAttr('style');
    $(window).scroll();
  });

  if ( $('.block-full--home-head-slider .slick-slide[data-slick-index="0"] .home-head-slide').hasClass('text-color-blue')) {
    $('.header').addClass('header-text-blue');
  }
});

// Quotes Slider
$(document).ready(function() {
	$('.block-full--reviews-slider .review-slider').each(function() {
		var $w = $(this);
		var $slides = $w.find('.review');
		while ( $slides.length < 4 ) {
			$slides.clone(true,true).appendTo($w);
			var $slides = $w.find('.review');
		}
	});

	$('.block-full--reviews-slider .review-slider').each(function() {
		var $w = $(this);
		$w.slick({
			dots: true,
			arrows: true,
			speed: 800,
			slidesToShow: 3,
			draggable: true,
			swipe: true,
			touchMove: false,
			swipeToSlide: false,
			centerMode: true,
			centerPadding: 0,
			infinite: true,
			adaptiveHeight: true,
			autoplay: true,
			autoplaySpeed: 4000,
			focusOnSelect: true,
      appendArrows: $('.review-slider-controls'),
      appendDots: $('.review-slider-controls'),
			responsive: [
				{
					breakpoint: 1024,
					settings: {
            autoplay: false,
						slidesToShow: 1,
						swipeToSlide: false,
					}
				},
			]
		});
		function slides_check ( nextSlide ) {
			//console.log(slick,currentSlide,nextSlide);
			var $ss = $w.find('.slick-slide');
			var slick = $w.slick('getSlick');
			$ss.each(function() {
				var $s = $(this);
				var slick_index = $s.data('slick-index');
				if ( slick_index === nextSlide
					|| slick_index === nextSlide - slick.slideCount
					|| slick_index === nextSlide + slick.slideCount
				) {
					$s.addClass('review-active');
				} else {
					$s.removeClass('review-active');
				}
				if ( slick_index >= nextSlide - 1 && slick_index <= nextSlide + 1
					|| slick_index >= nextSlide - slick.slideCount - 1 && slick_index <= nextSlide - slick.slideCount + 1
					|| slick_index >= nextSlide + slick.slideCount - 1 && slick_index <= nextSlide + slick.slideCount + 1
				) {
					$s.addClass('review-visible');
				} else {
					$s.removeClass('review-visible');
				}
			});
		}
		$w.on('beforeChange',function( e, slick, currentSlide, nextSlide ) {
			slides_check ( nextSlide );
		});
		slides_check( 0 );
	});

});

// CTA block
$(document).ready(function() {

	$('.block-full--cta-sep').each(function() {
		var $b = $(this);
		$b.prev('.block-full').addClass('bot-2-pad');
		$b.next('.block-full').addClass('top-2-pad');
	});

	$('.block-full--team').each(function() {
		var $b = $(this);
		var $bp = $b.prev('.block-full');
		if ( $bp.length ) {
			$bp.addClass('bot-2-pad');
			$b.addClass('top-no-pad')
		}
	});
});

// Header dots resize
$(window).resize(function() {
	$('.block-full--blue-light-white-image.blw-type-sub').each(function() {
		var $w = $(this);
		var ih = $w.find('.blw-image-wrap').height();
		var $d = $w.find('.blw-text2-wrap .dots-array');
		if ( $w.height() - ih < $d.height() + 40 ) {
			$d.hide();
		} else {
			$d.show();
		}
	});
  $('.block-full--blue-light-white-image.blw-type-sub-no-crumbs').each(function() {
    var $w = $(this);
    var ih = $w.find('.blw-blue-light').height();
    var $d = $w.find('.blw-sub-bot-dots .dots-array');
    if ( $w.height() - ih < $d.height() + 40 ) {
      $d.hide();
    } else {
      $d.show();
    }
  });
});

// Messages
$(document).ready(function() {
	$(document).on('click', '.drupal-messages .close', function () {
		var $m = $(this).closest('.drupal-messages');
		$m.slideUp(500);
	});
});

Drupal.behaviors.sw_messages_theme = {
	attach: function( context, settings ) {
		$('.drupal-messages-page-wrap .drupal-messages').once('sw_messages').each(function() {
			$(this).addClass('processed');
			$(this).append('<span class="close"></span>');
		});
	}
};
setTimeout(function() {
	Drupal.theme.ajaxProgressThrobber = function () {
		return '<div class="sw-ajax-form-wrap-overlay">'+wait()+'</div>';
	};

	if ( typeof Drupal.AjaxCommands !== 'undefined' ) {
    // Override scroll top to offset header
    Drupal.AjaxCommands.prototype.viewsScrollTop = function( ajax, response ) {
      var offset = $(response.selector).offset();
      var $header = $('.header-pad');
      var $header2 = $('.header-banner-pad');
      var scroll_to = offset.top - $header.height() - $header2.height();
      var scrollTarget = response.selector;

      while ( $(scrollTarget).scrollTop() === 0 && $(scrollTarget).parent() ) {
        scrollTarget = $(scrollTarget).parent();
      }

      if ( scroll_to < $(scrollTarget).scrollTop() ) {
        $(scrollTarget).animate({
          scrollTop: scroll_to
        }, 500);
      }
    };
  }
}, 100);

// Header Banner resize
$(window).resize(function() {
  var $h = $('.header');
  var $hp = $('.header-banner-pad');
  var $b = $('.header-banner');
  var $head_full = $('.block-full--home-head-slider.first');
  var $head_shrink = $('.block-full--history-slider.first .history-slide');
  if ( $b.length ) {
    var bh = $b.outerHeight();
    var hh = $h.height();
    var vh = $(window).height();
    $h.css({
      top: bh,
    });
    $hp.height(bh);
    if ( $head_full.length ) {
      $head_full.css('margin-top',-bh);
    }
    if ( $head_shrink.length ) {
      $head_shrink.height(vh - hh - bh);
    }
  }
});

// Share
$(document).on('click', '.share-wrap .share-cta', function() {
  var $wrap = $(this).closest('.share-wrap');
  var $options = $wrap.find('.share-options');
  $wrap.toggleClass('open');
  if ( $wrap.hasClass('open')) {
    $options.fadeIn(300);
  } else {
    $options.fadeOut(300);
  }
});
$(document).on('click', function(e) {
  if ( !$(e.target).is('.share-wrap') && !$(e.target).closest('.share-wrap').length ) {
    $('.share-wrap.open').each(function() {
      var $wrap = $(this);
      var $options = $wrap.find('.share-options');
      $wrap.removeClass('open');
      $options.fadeOut(300);
    });
  }
});

// Header search
$(document).on('click','.js-search-open', function(e) {
  e.preventDefault();
  $('.header--search').addClass('active');
  $('.header--search input[type="text"]').focus();
});
$(document).on('click','.js-search-close', function(e) {
  e.preventDefault();
  $('.header--search').removeClass('active');
});

// CTA Links
$(document).on('click', '.js-cta-link-cta', function() {
  var id = $(this).data('cta-link');
  if ( id ) {
    var $a = $('a#'+id);
    var href = $a.attr('href');
    if ( href ) {
      window.location.href = href;
    }
  }
});

// Scroll Down
$(document).on('click', 'a[href*="#"]', function( e ) {
  var regex = /#(.*)$/gi;
  var href = $(this).attr('href');
  var m = regex.exec(href)
  if ( m ) {
    var id = m[1];
    var $block = $('#'+id);
    if ( $block.length ) {
      e.preventDefault();
      scrollto($block);
    }
  }
});

// Phone Mask
Drupal.behaviors.sw_phone_mask = {
  attach: function( context, settings ) {
    $('input[type="tel"]').once('sw_phone_mask').each(function() {
      var mask = IMask(this, {
        mask: '(000) 000 0000',
      });
    });
  }
};

/**
 * Recaptcha bug fix with ajax rendering form.
 */
Drupal.behaviors.sw_recapcha_ajax_behaviour = {
  attach: function(context, settings) {
    if (typeof grecaptcha != "undefined" && typeof grecaptcha.render != 'undefined') {
      var captchas = document.getElementsByClassName('g-recaptcha');
      for (var i = 0; i < captchas.length; i++) {
        var site_key = captchas[i].getAttribute('data-sitekey');
        if (!$(captchas[i]).html()) {
          grecaptcha.render(captchas[i], { 'sitekey' : site_key});
        }
      }
    }
  }
}
